import React from 'react';
import CampaignBadge from 'src/components/campaign-badge';
import { Badge } from '@prisjakt/ui/badge';
import { ShippingLabel, PriceLabel } from '../../../../components/price-column';
import StockInfo from '../../../../components/stock-info';
import PriceTypeNotice from '../../../../components/stock-info/price-type-notice';
import { IStockPriceInfo } from '../../../../types';
import * as S from './styles';

const StockPriceInfo: React.FC<IStockPriceInfo> = props => {
  const {
    featured,
    campaign,
    price,
    priceDisplay,
    priceType,
    stock,
    isMemberPrice,
  } = props;

  return (
    <S.PriceColumn>
      <S.PriceAndStockRow featured={featured}>
        {price && featured && (
          <ShippingLabel price={price} priceDisplay={priceDisplay} />
        )}
        {featured && (
          <StockInfo
            status={stock && stock.status}
            statusText={stock && stock.statusText}
            toneDown={!featured}
          />
        )}
        <S.PriceLabelWrapper>
          <S.BadgeWrapper>
            {campaign && <CampaignBadge colors={campaign.media.colors} />}
            {featured && isMemberPrice && (
              <Badge color="GREY_INVERTED" text="Members" />
            )}
          </S.BadgeWrapper>
          {price && (
            <PriceLabel
              price={price}
              priceDisplay={priceDisplay}
              storeIsFeatured={featured}
              isCampaign={Boolean(campaign)}
            />
          )}
        </S.PriceLabelWrapper>
      </S.PriceAndStockRow>
      <S.PriceTypeNoticeRow>
        {featured && <PriceTypeNotice priceType={priceType} />}
      </S.PriceTypeNoticeRow>
    </S.PriceColumn>
  );
};

export default StockPriceInfo;
